// Global components
import 'alpinejs/dist/cdn';
import Cookies from 'js-cookie';
import 'shariff/dist/shariff.complete.js';
import './PowermailScrollAfterSubmit';
import { UserCentricsService } from './Services/UserCentricsService';
import {Slider} from "./Slider";

window.Cookies = Cookies;

// Initialize and expose UserCentricsService globally
window.UserCentricsService = new UserCentricsService();

/**
 * Global body watcher to set alpine variables dynamically
 */
document.addEventListener('alpine:init', () => {
    Alpine.bind('bodyWatcher', () => ({
        type: 'body',

        '@resize.window'() {
            this.headerOffsetTop = document.querySelector('.o-header').getBoundingClientRect().height
        },

        '@scroll.window'() {
            this.onScroll = (window.pageYOffset > 0) ? true : false
        },

        'x-init'() {
            this.headerOffsetTop = document.querySelector('.o-header').getBoundingClientRect().height;
            this.$watch('modalRegionOpened,modalCustomerPortalOpened', value => {
                this.headerOffsetTop = document.querySelector('.o-header').getBoundingClientRect().height
            });
            this.$watch('showFoldout,foldoutSitemapActive', value => {
                this.headerHeight = document.querySelector('.o-header').getBoundingClientRect().height
            });
            this.$watch('burgerActive', value => {
                let offCanvasWrapper = document.querySelector('.o-offcanvas__wrapper');
                if (value === true) {
                    offCanvasWrapper.style.height = '100%';
                } else {
                    setTimeout(function () {
                        offCanvasWrapper.style.height = '0';
                    }, 300)
                }
            });
        }
    }));

    Alpine.data('filterCountryList', () => ({
        searchString: '',
        submitSearch(el) {
            this.searchString = el.value;
        },
        showCountry(el) {
            if (this.searchString === '') {
                return true;
            } else {
                for (let i in el.dataset) {
                    if (i.startsWith('shortname') && el.dataset[i].toLowerCase().includes(this.searchString.toLowerCase())) {
                        return true;
                    }
                }
            }
            return false;
        },
        watchRegion(searchValue, el) {
            this.accordionOpen = searchValue !== '';
            this.showAccordion = searchValue === '' || el.querySelectorAll('.c-country-list__country:not(.d-none)').length > 0;

            if (document.querySelectorAll('.c-country-list__country:not(.d-none)').length === 0) {
                this.showNotFound = true;
            } else {
                this.showNotFound = false;
            }
        },
        watchListHeight(showAccordion, el) {
            if (this.accordionOpen && showAccordion) {
                // need to set a timout for 0 seconds here because otherwise scroll height is always 0px
                setTimeout(function () {
                    el.style.maxHeight = el.scrollHeight + 'px';
                }, 0)
            }
        },
        watchSearchInput(value, oldValue) {
            if (value.length > 2 || oldValue.length > value.length) {
                this.searchString = value;
            } else {
                this.searchString = '';
            }
        }
    }));
});

// Fixing scroll Height for different usecases
document.addEventListener("DOMContentLoaded", function(event) {
    let hash = window.location.hash;
    if (hash) {
        let headerHeight = document.querySelector('.o-header').clientHeight + 10;
        let htmlElement = document.querySelector('html');
        htmlElement.style.scrollPaddingTop = headerHeight + 'px';
    }
});

document.querySelectorAll('[data-slider]').forEach((slider) => new Slider(slider, slider.dataset.slider ?? ''));